import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVisionPro: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="vision-pro, goggles">
      <path
        d="M12 15C9.5 15 9.5 18 6 18C2.5 18 1 15 1 12C1 6.5 7 5.99998 12 6C17 6.00002 23 6.5 23 12C23 14.9355 21.5 18 18 18C14.5 18 14.5 15 12 15Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </CentralIconBase>
  );
};

export default IconVisionPro;
